import * as React from 'react';

import cn from 'classnames';

import { getConfig } from '@constants';

import { Feedback } from '@common/components/Feedback';

import { IDmcaPageProps } from '../../types';

import * as s from './DmcaFooter.scss';

const DmcaFooterComponent = ({
	classNames: {
		content: contentClassName,
	},
}: IDmcaPageProps) => {
	const { copyright } = getConfig();

	return (
		<div className={s.block}>
			<div className={cn(s.content, contentClassName)}>
				<Feedback/>

				<div className={s.copyright}>{copyright}</div>
			</div>
		</div>
	);
};

export const DmcaFooter = React.memo(DmcaFooterComponent, () => true);